import { BeneficiaryCtrl } from '../components'
import { useContext, useEffect, useState } from "react"
import { DataContext } from "../data/DataContext"
const StepBeneficiaries = () => {
    const { vidaCR, setVidaCR, changeHandler, changeHandler2 } = useContext(DataContext);
    const [colorBtn, setColorBtn] = useState("#008866")
    const [lstBenef, setLstBenef] = useState(vidaCR.lstBeneficiary)


    const AddBeneficiary = (e: any) => {
        e.preventDefault();
        let lst = vidaCR.lstBeneficiary;
        lst.push({
            id: 2,
            identification: '',
            typeDocument: '1',
            lastname1: '',
            lastname2: '',
            name1: '',
            name2: '',
            percentage: '',
            relationship: ''
        } as IBeneficiary)
        setVidaCR({ ...vidaCR, lstBeneficiary: lst })
    }

    const RemoveBeneficiary = (e: any) => {
        e.preventDefault();
        console.log(vidaCR.lstBeneficiary);
        let lst = vidaCR.lstBeneficiary;
        let result = lst?.filter(x => x.id == 1);
        setVidaCR({ ...vidaCR, lstBeneficiary: result })

    }

    useEffect(() => {
        setLstBenef(vidaCR.lstBeneficiary); 
    }, [vidaCR.lstBeneficiary])

    return <>
        {lstBenef.map((x) => { return <BeneficiaryCtrl {...x} /> })}
        <div className='mt-20' style={{ display: 'flex' }}>

            {lstBenef.length === 1 && <>
                <button style={{ background: '#008866' }} className='btn-add-vida-cr' onClick={AddBeneficiary}>
                    <label>+</label>
                </button>
                <span className='ml-10 lbl-input-vida-cr'>
                    <label>Agregar un beneficiario más</label>
                </span>
            </>
            }
            {lstBenef.length === 2 &&
                <>
                    <button style={{ background: '#D43C37' }} className='btn-add-vida-cr' onClick={RemoveBeneficiary}>
                        <label>-</label>
                    </button>
                    <span className='ml-10 lbl-input-vida-cr'>
                        <label>Eliminar segundo beneficiario</label>
                    </span>
                </>
            }

        </div >

    </>
}

export { StepBeneficiaries };